import { render } from "./AboutUs.vue?vue&type=template&id=f992d5e8&scoped=true"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=f992d5e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f992d5e8"

export default script